<template>
  <div class="wrap">
    <div class="database-table">
      <el-table
        :data="tableData"
        ref="multipleTable"
        tooltip-effect="dark"
        style="width: 100%"
        @filter-change="handleFilterChange"
        v-loading="loading"
      >

        <el-table-column :label="$t('bill.orderList.tNnmber')" prop="sn"> </el-table-column>
        <el-table-column :label="$t('bill.orderList.zone')">
          <template slot-scope="scope">
            <p v-html="scope.row.zone || '-' "></p>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('bill.orderList.oType')"
          prop="type"
          column-key="orderType"
          :filters="oTypeList"
        >
        </el-table-column>

        <el-table-column
          :label="$t('bill.orderList.pType')"
          prop="product_code"
          column-key="productType"
          :filters="pTypeList"
        >
        </el-table-column>
        <el-table-column :label="$t('bill.orderList.charge')">
          <template slot-scope="scope">
            <p>{{ $store.state.currency }} {{ $util.convertCurrency(scope.row.pay_amount) }}</p>
          </template>
        </el-table-column>
        <el-table-column :label="$t('bill.orderList.status')">
          <template slot-scope="scope">
            <p v-if="scope.row.status === 0" class="gray">{{ scope.row.status_text }}</p>
            <p v-else-if="scope.row.status === -2 || scope.row.status === -1" class="red">{{ scope.row.status_text }}</p>
            <p v-else-if="scope.row.status === 1" class="yellow">{{ scope.row.status_text }}</p>
            <p v-else-if="scope.row.status === 2" class="green">{{ scope.row.status_text }}</p>
          </template>
        </el-table-column>
        <el-table-column :label="$t('bill.orderList.time')">
          <template slot-scope="scope">
            <p>{{ scope.row.create_time }}</p>
            <p class="gray">{{scope.row.pay_time || "-" }}</p>
          </template>
        </el-table-column>
        <el-table-column :label="$t('bill.orderList.actions')" width="160">
          <template slot-scope="scope">
            <ul class="actions">
              <li @click="viewChange(scope.row.sn)">{{$t('bill.orderList.view')}}</li>
              <li @click="gopay(scope.row)" v-show="scope.row.status ==0 && scope.row.pay_status == 0">
                {{$t('bill.orderList.pay')}}
              </li>
            </ul>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagebox">
      <el-pagination
        background
        @current-change="handleCurrenChange"
        @size-change="handleSizeChange"
        :page-sizes="zizes"
        :current-page="page"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 查看账单 -->
    <ViewOrder ref="ordermodal" />

    <!-- 支付订单 -->
    <PayOrder ref="paymodal" />
  </div>
</template>

<script>
import ViewOrder from "@/components/user/ViewOrder";
import PayOrder from "@/components/user/PayOrder";
export default {
  data() {
    return {
      loading:false,
       keyword:'',
        pTypeList:[],
        oTypeList:[],
        total:1,
        zizes:[10,20,30,50,100],
        size:10,
        page:1,
        orderType:'',
        productType:'',
        start:'',
        end:'',
      tableData: [

      ],
      multipleSelection: [],
    };
  },
  components: {
    ViewOrder,
    PayOrder,
  },

  methods: {
    // toggleSelection(rows) {
    //   if (rows) {
    //     rows.forEach((row) => {
    //       this.$refs.multipleTable.toggleRowSelection(row);
    //     });
    //   } else {
    //     this.$refs.multipleTable.clearSelection();
    //   }
    // },
    // handleSelectionChange(val) {
    //   this.multipleSelection = val;
    // },

    /**查看***/
    viewChange(sn) {
      this.$refs.ordermodal.showChange(sn);
    },
    /****支付*****/
    gopay(order) {
      this.$refs.paymodal.order = order;
      this.$refs.paymodal.showChange();
    },
    getList(){
      this.loading = true;
        let obj={
            page:this.page,
            pageNum:this.size,
            orderType:this.orderType,
            productType:this.productType,
            start:this.start,
            end:this.end,
           keyword:this.keyword,
        }
        this.$http.post('/home/billing/getOrderList', obj).then((res) => {
          this.loading = false;
            res = res.data.data;
            this.tableData = [];
            this.tableData = res.data;
            this.total = res.total;
        }).catch((err) => {
            this.$util.handleErr(err);
        })
    },
      getType(){
          this.$http.post('/home/billing/getProductAndOrderType',{}).then((res) => {
              res = res.data.data;
              this.pTypeList = res.product;
              this.oTypeList = res.order;
          }).catch((err) => {
              this.$util.handleErr(err);
          })
      },
      handleCurrenChange:function(current){
          //页码更新
          this.page = current;
          //加载数据
          this.getList();
      },
      handleSizeChange(size){
          //数量更新
          this.size = size;
          //加载数据
          this.getList();
      },
      handleFilterChange(obj){
          this.$refs.multipleTable.clearSelection();
          this.orderType = obj.hasOwnProperty("orderType")
              ? obj.orderType.join(",")
              : this.orderType;
          this.productType = obj.hasOwnProperty("productType")
              ? obj.productType.join(",")
              : this.productType;
          this.getList();
      },
  },
};
</script>
<style scoped lang="scss">
.actions {
  display: flex;
  li {
    margin-right: 24px;
    color: #3377ff;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/billing/TabOrder.vue